export default "__VITE_ASSET__DFiekhGe__"